import { useQuery } from '@tanstack/react-query';
import { getUserCases } from '../api/reportsApi';
import { msalInstance } from '@utils';
import { useMediaQuery } from './useMediaQuery';

export const useRecentReports = () => {
  const MOBILE_ITEMS_PER_PAGE = 2;
  const DESKTOP_ITEMS_PER_PAGE = 5;

  const itemsPerPage = useMediaQuery('(max-width: 767px)')
    ? MOBILE_ITEMS_PER_PAGE
    : DESKTOP_ITEMS_PER_PAGE;

  return useQuery({
    queryKey: ['recentReports'],
    queryFn: () => getUserCases({ page: 1, page_size: itemsPerPage }),
    enabled: msalInstance.getAllAccounts().length > 0,
    staleTime: 30 * 1000,
  });
};
